module.exports = __webpack_public_path__ + "img/mediator.6de8db70.png";